export default (theme) => ({
  root: {
    display: 'flex',
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(0),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  contentBox: {
    paddingTop: 15,
  },
  fab: {
    margin: theme.spacing(2),
  },
  formControl: {
    marginTop: 20,
  },
  removeOnHover: {
    display: 'flex',
    flex: 1,
    '& span': {
      marginLeft: 'auto',
      visibility: 'hidden',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    '&:hover': {
      '& span': {
        visibility: 'visible',
      },
    },
  },
});
